<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Sample Order Cart</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
    <app-sample-order [isModal]="true" />
    <!-- @switch(page()) {
    @case(1) {
    <app-sample-order />
    <div class="text-center">
        <button class="btn btn-primary" type="button" (click)="page.set(2)">
            <span class="btn-primary-hover"></span>
            <span class="btn-content">Checkout</span>
        </button>
    </div>
    }
    @case(2) {
    <div class="sample-order">
        <form [formGroup]="cartQuoteForm" (ngSubmit)="onSubmitQuote()">
            <div>
                <h4 class="title">Information</h4>
                <div>
                    <div class="form-group">
                        <label class="form-label">Project Name</label>
                        <input type="text" class="form-control" placeholder="Enter project name"
                            formControlName="project_name">
                        @if(f['project_name'].invalid && f['project_name'].touched &&
                        (f['project_name'].errors?.['required'] || f['project_name'].errors?.['whitespace'] ||
                        f['project_name'].errors?.['apiError'])) {
                        <span class="required-message">Please enter project name</span>
                        }
                    </div>
                    <div class="form-group">
                        <label class="form-label">Description</label>
                        <input class="form-control" formControlName="description" type="text" />
                    </div>
                </div>
                <h4 class="title">Order Summary</h4>
                <app-sample-order [hideProgressBar]="true" />
            </div>
        </form>
    </div>
    <div class="text-center">
        <button class="btn btn-primary" type="submit" (click)="onSubmitQuote()">
            <span class="btn-primary-hover"></span>
            <span class="btn-content">Confirm</span>
        </button>
    </div>
    }
    } -->
</div>
